//  React base styles
import borders from 'assets/theme/base/borders';
import colors from 'assets/theme/base/colors';
import typography from 'assets/theme/base/typography';

//  React helper functions
import pxToRem from 'assets/theme/functions/pxToRem';

const { light, text, dark, black, white, transparent, grey } = colors;
const { borderRadius } = borders;
const { size } = typography;

const menuItem = {
  styleOverrides: {
    root: {
      minHeight: 'unset',
      padding: `${pxToRem(4.8)} ${pxToRem(16)}`,
      marginBottom: pxToRem(2),
      borderBottom: '1px solid #DEE4F9',
      fontSize: size.sm,
      color: black.main,
      transition: 'background-color 300ms ease, color 300ms ease',
      backgroundColor: white.main,
      borderRadius: borderRadius.md,

      '&:last-child': {
        marginBottom: 0,
      },

      '&:focus, &.Mui-selected, &.Mui-selected:focus': {
        // backgroundColor: transparent.blue,
        backgroundColor: '#00E0EB33',
      },

      '&::after': {
        width: '20px',
      },

      '&:hover, &.Mui-selected:hover': {
        // backgroundColor: transparent.blue,
        backgroundColor: grey[300],
        color: black.main,
      },
    },
  },
};

export default menuItem;
